export const config = {
  theme: {
    transcription: {
      backgroundColor: "#F8FBFD",
    },
    paragraph: {
      heading: {
        speakerAvatar: {
          width: 24,
          height: 24,
          borderRadius: 24,
        },
        speaker: {
          fontSize: 12,
          lineHeight: 20,
          color: "var(--Text_Caption)",
        },
      },
      paddingVertical: 16,
      paddingHorizontal: 24,
      borderRadius: 8,
      backgroundColor: "var(--Fill_Tertiary)",
      marginTop: 0,
      marginBottom: 20,
    },
    textEditor: {
      fontSize: 14,
      lineHeight: 24,
      color: "var(--Text_Primary)",
    },
  },
};
